import { lazy } from 'react';

export const MedicalDeviceTypeDetailsPage = lazy(
  () => import('./MedicalDeviceTypeDetailsPage'),
);
